module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-72x72-8319c71d9d4a6271120187e86c435576.png";